export const fakePortalConfig = {
  "data": {
    "enableAutoProvision": true,
    "enableVMS": false
  }
}
